// extracted by mini-css-extract-plugin
export default {"page":"Fps0ia72","mainWrapper":"cli8mEUV","main":"vqtOWotG","title":"sDkmFsrx","subtitle":"y6KuJt2z","tabsWrapper":"LdSXMVDH","levelSelector":"KgmE1DyL","categorySelector":"mAVRvMCq","tabs":"RzzJbhs_","transactionTitle":"Qr7z6Nui","transactionCardsWrapper":"Ev1WqWbZ","totalSumTitle":"Eq2hCgni","activeTab":"jfSpL6TK","activeCategoryTab":"dohS2MWm","backToGameButton":"hvb3obFi","spendsWrapper":"w143ucc2","spendText":"QvWMOcZE","outcomeText":"Qxakf3FP","incomeText":"p_uKo5I7"};
    if(module.hot) {
      // 1738090061125
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  